import {
  GlobalGroupProducts,
  GroupAttributeCodeOptionDependency,
  GroupAttributeCodeSetSource,
  GroupParentAttributeOptionSet,
  SelectedOptionparent,
  SelectedOptionStringify,
  SelectedOptionStringifyGroupInfo,
} from "@/components/configurator/global-option/types";

export default class Serialize {
  static readonly groupParentAttributeOptionSet = (
    data: GroupParentAttributeOptionSet,
  ): string => {
    const selectedOptionsToStoreLocal: SelectedOptionStringify[] = [];

    Array.from(data.keys()).forEach((key) => {
      const parentMap = data.get(key);
      let parentToStoreLocal: SelectedOptionparent[] = [];
      if (parentMap) {
        parentToStoreLocal = [];
        Array.from(parentMap.parents.keys()).forEach((parentKey) => {
          const value = parentMap.parents.get(parentKey);
          if (value) {
            parentToStoreLocal.push({
              parentKey: parentKey,
              value: value,
            });
          }
        });
      }
      const groupInfo: SelectedOptionStringifyGroupInfo = {
        groupId: parentMap?.groupId ?? "",
        groupName: parentMap?.groupName ?? "",
        isProduct: parentMap?.isProduct ?? false,
        isCollapsed: parentMap?.isCollapsed ?? false,
        isGrayOut: parentMap?.isGrayOut ?? false,
        isDisabled: parentMap?.isDisabled ?? false,
        isVisible: parentMap?.isVisible ?? false,
        isTooltipVisible: parentMap?.isTooltipVisible ?? false,
        isChildDependentOnMainBody: parentMap?.isChildDependentOnMainBody ?? false,
        isMiscellaneous: parentMap?.isMiscellaneous ?? false,
        tooltipData: parentMap?.tooltipData ?? {
          type: "text",
          text: "<Tooltip Data>",
          images: [],
        },
        selectionType: parentMap?.selectionType ?? "",
      };
      selectedOptionsToStoreLocal.push({
        groupKey: key,
        groupInfo: groupInfo,
        parents: parentToStoreLocal,
      });
    });

    return JSON.stringify(selectedOptionsToStoreLocal);
  };

  static readonly globalGroupProducts = (data: GlobalGroupProducts): string => {
    return JSON.stringify([...data]);
  };

  static groupAttributeCodeOptionDependency(
    data: GroupAttributeCodeOptionDependency,
  ): string {
    const serialized: Record<
      string,
      Record<string, Record<string, number[]>>
    > = {};

    data.forEach((optionMap, groupKey) => {
      const groupKeyString = JSON.stringify(groupKey);
      serialized[groupKeyString] = {};

      optionMap.forEach((optionDependency, attributeCode) => {
        serialized[groupKeyString][attributeCode] = {};

        optionDependency.forEach((dependentKeys, optionKey) => {
          serialized[groupKeyString][attributeCode][JSON.stringify(optionKey)] =
            Array.from(dependentKeys);
        });
      });
    });

    return JSON.stringify(serialized);
  }

  static readonly groupAttributeCodeSetSource = (
    data: GroupAttributeCodeSetSource,
  ): string => {
    return JSON.stringify([...data]);
  };
}
